export const addLeadingZero = (number: number): string => {
  if (number || number === 0) {
    return ("0" + Number(number).toString()).slice(-2);
  } else return "";
};
